import { usePage } from '@inertiajs/vue3'
import { computed, ComputedRef } from 'vue'

export type AuthUser = {
  id: number
  name: string
  email: string
  organization_id: number
  is_super_admin: boolean
  first_name: string
  profile_photo_url: string | null
  authorizations: Record<string, Record<string, boolean>>
  time_clock_href?: string | null
  unread_notifications_count: number
}

export type AuthOrganization = {
  id: number
  name: string
  [key: string]: unknown
}

export const useUser: ComputedRef<AuthUser> = computed(
  () => usePage().props?.authUser as AuthUser
)

export const useOrganization: ComputedRef<AuthOrganization> = computed(
  () => usePage().props?.authOrganization as AuthOrganization
)
